import { all, call, put, takeLeading, select } from 'redux-saga/effects';
import { getProfilesList } from './Profile';
import { getPlansList } from './Plans';
import { actions, types } from '@src/store';
import localStore from '@src/utils/storage';
import { history } from '@src/routes';
import {
  fetchLogin,
  fetchSignUp,
  requestLogout,
  updateUser,
} from '@src/apis/User';
import {
  selectCurrentProfile,
  selectSubscriberId,
  selectSubscriberEmail,
  selectCommonAnalytics,
  selectLanguageMeta,
} from '@src/store/selectors';

import analytics from '@src/firebase/analytics';
import { KochavaSetup } from '../..';

const logger = Logger.get('sagas/user');

function* userSaga() {
  yield all([
    takeLeading(types.user.RefreshUser, refreshUser),
    takeLeading(types.user.LoginUser, getLogin),
    takeLeading(types.user.SignupUser, getSignUp),
    takeLeading(types.user.UpdateLanguage, updateLanguage),
    takeLeading(types.user.LogoutUser, getLogout),
    takeLeading(types.user.LogoutUserPassword, getLogoutPassword),
  ]);
}

function* refreshUser() {
  try {
    let userData = yield call(fetchLogin, {}, true);

    yield put(actions.user.DataSuccess(userData));

    yield getPlansList();
  } catch (e) {
    localStore.remove('__userdata__');
    logger.log('user could not be refreshed', e);
  }
}

export function* getLogin({ payload, autoLogin }) {
  const commonAnalytics = yield select(selectCommonAnalytics);
  try {
    debugger;

    yield put(actions.common.SetLoader(true));

    let userData = yield call(fetchLogin, payload, autoLogin);

    if (userData.error) throw userData.error;
    yield put(actions.user.DataSuccess(userData));

    yield call(getProfilesList);

    //get currentprofile level...

    const profile = yield select(selectCurrentProfile);

    const profileid = profile?.profileid ?? localStore.get('__selectedProfile');

    console.log("UDDD",userData);

    if (profileid) yield put(actions.profile.SelectProfile({ profileid }));

    yield put(actions.user.IsAuthenticated({ isAuthenticated: true }));

    yield put(actions.common.SetLoader(false));

    // GOOGLE ANALYTICS
    if (payload?.gtoken && userData?.firstTimeLogin)
      analytics.logEvent('REGISTER', {
        ...commonAnalytics,
        ...{
          Mode: 'GOOGLE',
          Email: userData?.email,
          Name: userData?.subscribername,
          SubscriberId: userData?.subscriberid,
          Status: 'SUCCESS',
        },
      });

    if (payload?.fbtoken && userData?.firstTimeLogin)
      analytics.logEvent('REGISTER', {
        ...commonAnalytics,
        ...{
          Mode: 'FACEBOOK',
          Email: userData?.email,
          Name: userData?.subscribername,
          SubscriberId: userData?.subscriberid,
          Status: 'SUCCESS',
        },
      });

    if (payload?.gtoken && !userData?.firstTimeLogin)
      analytics.logEvent('LOGIN', {
        ...commonAnalytics,
        ...{
          Mode: 'GOOGLE',
          Email: userData?.email,
          Name: userData?.subscribername,
          SubscriberId: userData?.subscriberid,
          Status: 'SUCCESS',
        },
      });

    if (payload?.fbtoken && !userData?.firstTimeLogin)
      analytics.logEvent('LOGIN', {
        ...commonAnalytics,
        ...{
          Mode: 'FACEBOOK',
          Email: userData?.email,
          Name: userData?.subscribername,
          SubscriberId: userData?.subscriberid,
          Status: 'SUCCESS',
        },
      });

    if (!payload?.fbtoken && !userData?.firstTimeLogin)
      analytics.logEvent('LOGIN', {
        ...commonAnalytics,
        ...{
          Mode: 'EMAIL',
          Email: userData?.email,
          Name: userData?.subscribername,
          SubscriberId: userData?.subscriberid,
          Status: 'SUCCESS',
        },
      });

    // KOCHAVA ANALYTICS

    if (!autoLogin)
      analytics.logEvent('LOGIN', {
        ...commonAnalytics,
        ...{ Status: 'SUCCESS' },
      });
  } catch (err) {
    logger.log('LOGIN ERR: ', err);
    yield put(actions.user.ResetData(err));
    yield put(actions.common.SetLoader(false));
    localStore.remove('__userdata__');

    if (autoLogin) return;

    const errorData = {
      type: 'login',
      message: 'Incorrect Username or Password',
    };
    yield put(actions.common.SetError(errorData));

    analytics.logEvent('LOGIN', {
      ...commonAnalytics,
      ...{ Status: 'FAILURE', ErrorMessage: err.reason, ErrorCode: err.code },
    });
  }
}
function* getSignUp({ payload }) {
  try {
    yield put(actions.common.SetLoader(true));

    yield call(fetchSignUp, payload);
    yield call(getLogin, { payload });

    logger.log('PL', payload);
    yield put(actions.common.SetLoader(false));
    const commonAnalytics = yield select(selectCommonAnalytics);
    const subscriberId = yield select(selectSubscriberId);
    const subscriberEmail = yield select(selectSubscriberEmail);
    // GA
    analytics.logEvent('REGISTER', {
      ...commonAnalytics,
      ...{
        Mode: 'EMAIL',
        Email: payload.email,
        Name: payload.subscribername,
        SubscriberId: subscriberId,
        Status: 'SUCCESS',
      },
    });
    // KOCHAVA
    const kochava = KochavaSetup();
    kochava.sendEvent('REGISTER', {
      ...commonAnalytics,
    });

    analytics.logEvent('SUBSCRIBERLANGUAGE', {
      ...commonAnalytics,
      ...{ LanguageName: 'English' },
    });
  } catch (err) {
    const commonAnalytics = yield select(selectCommonAnalytics);

    logger.log('SIGNUP ERR: ', err);
    yield put(actions.user.ResetData(err));

    yield put(actions.common.SetLoader(false));
    const errorData = {
      type: 'signup',
      message: err?.reason ?? 'Signup request Failed!',
    };
    yield put(actions.common.SetError(errorData));
    analytics.logEvent('REGISTER', {
      ...commonAnalytics,
      ...{
        Status: 'FAILURE',
        Email: payload.email,
        ErrorMessage: err.reason,
        ErrorCode: err.code,
      },
    });
  }
}

function* updateLanguage({ payload }) {
  const commonAnalytics = yield select(selectCommonAnalytics);
  try {
    yield put(actions.common.SetLoader(true));
    const subscriberId = yield select(selectSubscriberId);
    yield call(updateUser, {
      subscriberId,
      preferredlanguage: payload.language,
    });
    yield put(actions.user.selectLanguage(payload));
  } catch (e) {
    logger.log(e);
  } finally {
    const language = yield select(selectLanguageMeta);
    yield put(actions.common.SetLoader(false));
    analytics.logEvent('SUBSCRIBERLANGUAGE', {
      ...commonAnalytics,
      ...{ LanguageName: language?.lang },
    });
  }
}

function* getLogout() {
  try {
    yield call(requestLogout);
    yield put({ type: 'LOG_OUT_ALL' });
  } catch (error) {
    logger.log('LOGOUT ERR: ', error);
  }
}

function* getLogoutPassword() {
  try {
    const useremail = yield select(selectSubscriberEmail);
    yield call(requestLogout);
    yield put({ type: 'LOG_OUT_ALL' });

    history.push({ pathname: '/login', state: { logout_email: useremail } });
  } catch (error) {
    logger.log('LOGOUT ERR: ', error);
  }
}

export default userSaga;
